import { useState } from "react";
import DealRequests from "./DealRequests";
import MyDealRequests from "./MyDealRequests";
import "../styles/Requests.scss";

export default function Requests() {
    const [activeTab, setActiveTab] = useState<"incoming" | "outgoing">("incoming");

    return (
        <div className="requests-page">
            <div className="requests-tabs">
                <button
                    className={`requests-tab ${activeTab === "incoming" ? "active" : ""}`}
                    onClick={() => setActiveTab("incoming")}
                >
                    📥 Входящие
                </button>
                <button
                    className={`requests-tab ${activeTab === "outgoing" ? "active" : ""}`}
                    onClick={() => setActiveTab("outgoing")}
                >
                    📤 Исходящие
                </button>
            </div>

            <div className="requests-content">
                {activeTab === "incoming" && <DealRequests />}
                {activeTab === "outgoing" && <MyDealRequests />}
            </div>
        </div>
    );
}
